import React, { lazy, Suspense, useContext } from "react";
import AllRoutes from "../../routes/index";
import { UserContext } from "../../App";

const Search = lazy(() => import("../search_bar/Search"));
const AgenceLocation = lazy(() => import("../map/AgenceLocation"));
const HomeList = lazy(() => import("../homelist/HomeList"));
const Footer = lazy(() => import("../../pages/footer/Footer"));

const COMPONENTS = [<Search />, <AgenceLocation />, <HomeList />];

function Main() {
  const TheUserContext = useContext(UserContext);
  const displayHomePage = TheUserContext.displayHomePage;
  const { sidebarIsOpen } = TheUserContext;

  return (
    <>
      {!sidebarIsOpen ? (
        <>
          {displayHomePage ? (
            <main className="main-ctn">
              {COMPONENTS.map((comp, index) => (
                <Suspense key={index} fallback={"Loading"}>
                  {comp}
                </Suspense>
              ))}
            </main>
          ) : (
            <AllRoutes />
          )}
          <Footer />
        </>
      ) : null}
    </>
  );
}

export default Main;
